import { css } from 'linaria';

export const featuresSection = css`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 38px;
  margin-bottom: 80px;

  @media (--only-desktop) {
    gap: 32px;
  }

  @media (--only-tablet) {
    gap: 24px;
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-bottom: 48px;
  }
`;

export const feature = css`
  display: flex;
  width: 372px;

  @media (--to-largeDesktop) {
    flex-direction: column;
    align-items: flex-start;
    width: 292px;
  }

  @media (--only-tablet) {
    width: 204px;
  }

  @media (--only-mobile) {
    flex-direction: row;
    width: auto;
  }
`;

export const featureImg = css`
  height: 80px;

  @media (--to-desktop) {
    margin-bottom: 16px;
  }

  @media (--only-mobile) {
    margin-bottom: 0;
  }
`;

export const featureText = css`
  && {
    margin: 7px 0 0 16px;

    @media (--to-desktop) {
      margin: 0;
      line-height: 22px;
    }

    @media (--only-mobile) {
      margin-left: 20px;
      line-height: 18px;
    }
  }
`;
